import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import { getMyTeamSummary } from "@/services/employeeService";

// Managing comes from the reporting line: anyone whose employees report to
// them is a manager, whatever their login. This holds the signed-in person's
// team and the company's manager duties, which decide the "My team" pages.

const NO_DUTIES = { leave: false, appraisals: false, pips: false, goals: false };
const EMPTY = { isManager: false, duties: NO_DUTIES, members: [] };

const TeamContext = createContext({ ...EMPTY, loading: false, refresh: () => {} });

export const useTeam = () => useContext(TeamContext);

export function TeamProvider({ children }) {
  const { user } = useAuth();
  const [team, setTeam] = useState(EMPTY);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user || user.role === "super_admin") {
      setTeam(EMPTY);
      return;
    }
    setLoading(true);
    try {
      const summary = await getMyTeamSummary();
      setTeam({
        isManager: Boolean(summary?.is_manager),
        duties: { ...NO_DUTIES, ...(summary?.duties || {}) },
        members: Array.isArray(summary?.members) ? summary.members : [],
      });
    } catch {
      setTeam(EMPTY);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <TeamContext.Provider value={{ ...team, loading, refresh }}>
      {children}
    </TeamContext.Provider>
  );
}
